import { setLocale } from 'yup'

import i18n from 'i18n'

export const yupConfig = () =>
  setLocale({
    mixed: {
      default: 'invalid',
      required: 'blank',
    },
    string: {
      max: ({ max }) => i18n.t('errors.tooLong', { count: max }),
      min: ({ min }: { min: number }) => ({
        key: 'tooShort',
        values: { count: min },
      }),
      matches: 'invalid',
      email: i18n.t('errors.invalidEmail'),
      length: ({ length }: { length: number }) => ({
        key: 'wrongLength',
        values: { count: length },
      }),
    },
    array: {
      max: ({ max }: { max: number }) => ({
        key: 'maxAnswers',
        values: { count: max },
      }),
    },
  })
